import React from 'react';

import { styled } from '@material-ui/core';

export const TopBarSpace = styled('div')({
  flex: 1,
});
